import { Text, VStack } from 'ui_2';

export const LoadingMessage = ({
  message,
  fullPageHeight = true,
}: {
  message: string;
  fullPageHeight?: boolean;
}) => {
  return (
    <VStack
      className={`flex ${
        fullPageHeight ? 'min-h-[100dvh]' : 'h-full'
      } items-center justify-center`}
    >
      <VStack className='max-w-4/5 rounded-[10px] border border-gray-100 bg-gray-50 p-4 text-center'>
        <Text>{message}</Text>
      </VStack>
    </VStack>
  );
};
